import { wrapInApolloProvider } from "owa-apollo/lib/react";
import { onCloseAppPane } from "owa-app-pane-group-actions";
import getDrawerPaneId from "owa-app-pane-group-utils/lib/getDrawerPaneId";
import { DrawerPane } from "owa-drawer";
import { observer } from "owa-mobx-react";
import { TimePanel as LazyTimePanel, TimePanelHeaderBar as LazyTimePanelHeaderBar, } from "owa-time-panel/lib/lazyCalendarBoot";
import { bodyContainer, header } from "./MyDayPane.scss";
import type { FunctionComponent } from "react";

const onMyDayClosePane = () => {
    onCloseAppPane("myDay");
};

const myDayPaneTitle = () => {
    return <LazyTimePanelHeaderBar onClosePanel={onMyDayClosePane}/>;
};

const defaultExport: FunctionComponent = observer(function MyDayPane() {
    return wrapInApolloProvider(<DrawerPane paneId={getDrawerPaneId("myDay")} headerText={myDayPaneTitle()} headerClassName={header} bodyClassName={bodyContainer} noPadding={true} role={"complementary"}>
            <LazyTimePanel onClosePanel={onMyDayClosePane}/>
        </DrawerPane>);
}, "MyDayPane");
export default defaultExport;
